import {APIURLLEGALES, APIURLDIGITALIZACIONTHUBAN, APIURLREINGENIERIALEGALES} from "../../const/backend"
import apiClient from "../../utils/apiClient";

class ApiServiceAdapter  {

  async fetchDocumentosDigitalizacion(body) { 
    const url=APIURLLEGALES + `/Documentos/listar`

    const response = apiClient.post(url,body, { withAuth: true, isJson: true });
    const data = await response
    return data;
  }
  async fetchDocumentosJuicioReingenieria(body) { 
    const url=APIURLREINGENIERIALEGALES + `/GetJuicioDocumentos`
    const response = apiClient.post(url,body, { withAuth: true, isJson: true, useReing: true });
    const data = await response
    return data;
  }

  async fetchDocumentosJuicioThuban(idJuicio) { 
    const url=APIURLDIGITALIZACIONTHUBAN + `/documentos/juicio?idjuicio=${idJuicio||''}`
    const response = apiClient.get(url)
    const data = await response

    return data;
  }

  async fetchDocumentosSiniestro(nroSiniestro) { 
    const url=APIURLLEGALES + `/documentos/siniestrosReing?nroSiniestro=${nroSiniestro||''}`
    const response = apiClient.get(url)
    const data = await response

    return data;
  }
  
  async fetchDocumentoJuicioPorId(idDocumento) { 
    const url=APIURLDIGITALIZACIONTHUBAN + `/documentos/juicio/obtenerPorId?documentoId=${idDocumento||''}`
    const response = apiClient.get(url, { isBlob: true })
    const data = await response

    return data;
  }

  async fetchDocumentoSiniestroPorId(idDocumento) { 
    const url=APIURLDIGITALIZACIONTHUBAN + `/documentos/siniestro/obtenerPorId?documentoId=${idDocumento||''}`
    const response = apiClient.get(url, { isBlob: true })
    const data = await response

    return data;
  }

  async fetchTiposDocumento() { 
    const url=APIURLLEGALES + `/documentos/TiposDocumento`
    const response = apiClient.get(url)
    const data = await response

    return data;
  }

}

export default ApiServiceAdapter;